goog.provide('el8.appchart.dialog.addMedOrderTemplate');

goog.require('el8.template.appchart.dialog.addMedOrderTemplate');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.NewDialog');

el8.appchart.dialog.addMedOrderTemplate = (function() {
    var _spec = null;

    var that = new el8.uiwidget.NewDialog({
        title: 'Save Rx Template',
        modal: true,
        autoHeight: true,
        width: 460
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'save', 'Save', function() {
            var medOrderTemplate = el8.practicedata.medOrderTemplates.create({});
            el8.practicedata.medOrderTemplates.saveItem(medOrderTemplate.populate(_spec));
            that.hide();
        }, true
    );
    buttonSet.addButton(
        'close', 'Dismiss', function() {
            that.hide();
        }, false
    );
    that.setButtonSet(buttonSet);

    var super_show = that.show;
    that.show = function(spec) {

        _spec = spec;
        super_show.call(that);
        that.setContent(
            el8.template.appchart.dialog.addMedOrderTemplate.content(spec)
        );
        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
    };

    that.isPendingUserCreatedMeds = function(spec) {
        // has a med name but no med Id
        return spec.name && spec.name !== spec.infoText && !spec.medicationId;
    };

    that.isMissingRequiredFields = function(spec) {
        return !spec.medicationId;
    };

    return that;

})();
